import './styles/integration-data-sources.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import { Link } from 'react-router-dom'

export default class IntegrationDataSources extends React.Component {  
  static propTypes = {
    integration: PropTypes.object,
  }

  render() {
    const { integration } = this.props

    if (!integration.dataSources || integration.dataSources.length === 0) return null

    return (
      <div className="integration-data-sources">
        <div className="title">Data Sources</div>

        {
          integration.dataSources.map((dataSource) => {
            return (
              <div key={dataSource.id} className="integration-data-sources-row">
                <Link to={`/dataSources/item/${dataSource.id}`}>{ dataSource.name }</Link>
              </div>
            )
          })
        }
      </div>
    )
  }
}
